import React from 'react';
import { DocumentsDropzone, TitleWithIcon } from 'components';
import { useTranslation } from 'react-i18next';

interface Props {
  participationId: string;
  className?: string;
}

export const ParticipationDocuments = ({
  className,
  participationId,
}: Props) => {
  const { t } = useTranslation();
  return (
    <div className={className}>
      <TitleWithIcon
        icon="ri-file-list-3-line"
        iconColor="blue"
        title={t('sessions.details.monitoring.documents.title')}
      />
      <DocumentsDropzone participationId={participationId} />
    </div>
  );
};
